import {
  observable,
  action,
  useStrict,
  runInAction,
  autorun,
  flow,
  set,
  toJS,
  computed
} from 'mobx';
import { Toast, Modal } from 'antd-mobile';
import Stores from 'config/Stores';
import { payActivityType, activityTypeMap, advanceSaleStatusMap } from 'utils/constants';
import Util from 'utils';
import Serv from './DetailServ';

class DetailMod {
  // 订单号
  @observable tradeNo = '';

  // 基本信息
  @observable info = {};

  @observable deliveryList = [];

  // 包裹列表
  // @observable productList = [];
  // @observable packageList = [];
  @observable productList = [];

  // 包裹列表的物流信息
  // @observable pkgDeliveryMap = {};

  // 活动信息列表
  @observable activityList = [];

  // 赠品列表
  @observable giftList = [];

  // 加价购商品列表
  @observable incPriceShop = [];

  // // 所赠优惠券列表
  // @observable couponGiftList = [];

  // 优惠券列表
  @observable couponList = [];

  // 活动信息
  @observable activityGoodsInfo = {};

  // 预售状态
  @observable advanceSaleStatus = '';

  // 检验是否可购买校验结果
  @observable checkData = {};

  // 合同的标题
  @observable agreementTitle = '';

  // 是否批量购物模式的资格购活动
  @observable isShoppingPatterns = false;

  fromQRCode = false;

  // 个人礼品仓 配置项
  @observable giftWarehouseConfig = {};

  // 薇美云仓(新仓) 配置项
  @observable newWarehouseConfig = {};

  // 获取不能快速退单的json
  @observable notFastRefund = [];

  /**
   * 修改参数逻辑
   */
  @action
  changeState(key, value) {
    this[key] = value;
  }

  /**
   * 清空状态
   */
  @action
  clearData() {
    this.tradeNo = '';
    this.info = {};
    this.productList = [];
    this.activityList = [];
    this.giftList = [];
    this.incPriceShop = [];
    this.couponList = [];
    this.fromQRCode = false;
  }

  /**
   * 抢购状态判断
   */
  @computed
  get panicBuyingStatus() {
    const { activityList = [] } = this;
    const { id } = Stores.AppMod.userInfo || {};
    let panicBuyingTip = [];
    const newActivityList = toJS(activityList) || [];
    if (Array.isArray(newActivityList) && newActivityList.length > 0) {
      newActivityList.forEach((item) => {
        if (+item.groupType === 1) {
          const { memberTradeRespDtoPageInfo } = item;
          const { list } = memberTradeRespDtoPageInfo;
          if (Array.isArray(list) && list.length > 0) {
            // sendStatus: 红包发放状态： 0 发放失败 1 发放成功;
            // secondStatus :第二状态，拼团抢购 ：0：抢购失败，1：抢购成功
            list.forEach((temp) => {
              const { secondStatus, sendStatus, userId } = temp || {};
              if (id == userId) {
                if (+secondStatus === 1) {
                  panicBuyingTip = ['请耐心等待发货'];
                } else {
                  panicBuyingTip = ['抢购失败，订单已取消', '退款原路返回'];
                }
              }
            });
          }
        }
      });
    }
    return panicBuyingTip;
  }

  // 计算赠品的数量
  @computed
  get getGiftCount() {
    let count = 0;
    this.giftList &&
      this.giftList.map((item) => {
        // 1实物、2券、3权益
        const { giftType } = item;

        // 只有实物的才进行计数
        `${giftType}` == '1' && (count = count + item.giftNum || 0);
      });

    return count;
  }

  // 计算加购商品的数量
  @computed
  get getAdditionCount() {
    let count = 0;
    this.incPriceShop &&
      this.incPriceShop.map((item) => {
        count = count + item.giftNum || 0;
      });

    return count;
  }

  /**
   * 获取基本信息
   */
  getOrderInfo = flow(function* () {
    try {
      let params = {};
      const { data, extFields } = yield Serv.getOrderInfo(this.tradeNo, params, this.fromQRCode);
      if (Stores.AppMod.token && data.deliveryInfo.deliveryAddress.indexOf('*') != -1) {
        const result = yield Stores.AppMod.getDecyptMsg({
          id: data.id,
          scene: 313,
          channel: ''
        });
        console.log('getOrderInfo', data, result);
        this.info = {
          ...data,
          deliveryInfo: {
            ...data.deliveryInfo,
            deliveryAddress: result
          }
        };
      } else {
        this.info = data;
      }
      if (this.info.agreementCode) {
        this.getAgreement(this.info.agreementCode);
      }
      if (
        extFields &&
        extFields.baseFreight !== undefined &&
        extFields.extraFreight !== undefined &&
        this.info &&
        this.info.payInfoRespDto
      ) {
        this.info.payInfoRespDto.freightAmount = extFields.baseFreight;
        this.info.payInfoRespDto.extraFreight = extFields.extraFreight;
      }
    } catch (error) {
      console.log('error', error);
    }
  });

  // 获取不能快速退单的json
  getNotFastRefund = flow(function* () {
    try {
      const data = yield Serv.getNotFastRefund();
      this.notFastRefund = (data && data.notFastRefund) || [];
    } catch (err) {
      console.log('err', err);
    }
  });

  /**
   * 获取生命银行
   */
  getAgreement = flow(function* (code) {
    if (!code) return;
    try {
      const { data } = yield Serv.getAgreement(code);
      this.agreementTitle = data.title;
    } catch (error) {}
  });

  // /**
  //  * 获取包裹列表
  //  */
  // getOrderProduct = flow(function*() {
  //   try {
  //     let params = {};
  //     const { data } = yield Serv.getOrderProduct(this.tradeNo, params);
  //     if (Array.isArray(data)) {
  //       this.packageList = data;
  //       data.forEach(item => {
  //         if (item.packageNo) this.getPkgDelivery(item.packageNo);
  //       });
  //     }
  //   } catch (error) {}
  // });

  // /**
  //  * 获取包裹物流
  //  * @param {String} packageNo - （包裹）物流单号
  //  */
  // getPkgDelivery = flow(function*(packageNo) {
  //   try {
  //     let params = {
  //       tradeNo: this.tradeNo,
  //       deliveryNo: packageNo,
  //     };
  //     const { data } = yield Serv.getDeliveryMsg(params);
  //     if (Array.isArray(data)) {
  //       set(this.pkgDeliveryMap, { [packageNo]: data[0] });
  //       this.pkgDeliveryMap = toJS(this.pkgDeliveryMap);
  //     }
  //   } catch (error) {}
  // });

  @action
  getDeliveryList = flow(function* (tradeNo) {
    try {
      console.log(89890, this.tradeNo);
      const { data } = yield Serv.getDeliveryList(tradeNo || this.tradeNo, this.fromQRCode);
      const { deliveryInfo, itemInfo } = data || {};
      this.deliveryList = deliveryInfo || [];
      this.productList = itemInfo || [];
      this.getOrderActivity(tradeNo);
      return deliveryInfo;
    } catch (err) {}
  });

  /**
   * 获取订单活动信息
   */
  getOrderActivity = flow(function* (tradeNo) {
    try {
      const { data } = yield Serv.getOrderActivity(tradeNo || this.tradeNo, this.fromQRCode);
      this.activityList = data || [];
      this.activityGoodsInfo = {};
      const _that = this;
      this.isShoppingPatterns = false;
      this.activityList.some((item) => {
        if (item.activityType == '6' && item.shoppingPatterns == '1') {
          _that.isShoppingPatterns = true;
        }
        if (
          item.activityType === payActivityType.ADVANCESALE ||
          item.activityType === payActivityType.GROUPBUY
        ) {
          const goodsId = _that.productList[0] ? _that.productList[0].itemSerial : '';
          _that.searchActivityGoodsInfo(goodsId, item.activityId);
          return true;
        }
      });
    } catch (error) {}
  });

  /**
   * 获取优惠活动信息
   */
  searchActivityGoodsInfo = flow(function* (goodsId, activityId) {
    try {
      const { data } = yield Serv.getActivityGoodsInfo(goodsId, activityId);
      this.activityGoodsInfo = data || {};
      // 预售
      if (this.activityGoodsInfo.activityType === activityTypeMap.advanceSale) {
        this.prepareAdvanceInfo();
      }
    } catch (error) {}
  });

  /**
   * 获取订单优惠券信息
   */
  getCouponMsg = flow(function* () {
    try {
      const { data } = yield Serv.getCouponMsg(this.tradeNo, this.fromQRCode);
      this.couponList = data || [];
      console.log(666, this.couponList);
    } catch (error) {}
  });

  /**
   * 加价购商品列表
   */
  getIncPriceShop = flow(function* () {
    try {
      const { data } = yield Serv.getIncPriceShop(this.tradeNo, this.fromQRCode);
      this.incPriceShop = data || [];
    } catch (error) {}
  });

  /**
   * 确认收货
   */
  takeOver = flow(function* (deliveryNo) {
    try {
      const params = {
        tradeNo: this.tradeNo,
        deliveryNo
      };
      yield Serv.takeOver(params);
      Toast.info('成功收货', 1);
      this.getOrderInfo();
      // this.getOrderProduct();
      this.getDeliveryList();
    } catch (error) {}
  });

  // 获取评论信息
  getComment = flow(function* (params) {
    try {
      const { resultCode, data } = yield Serv.getComment(params);
      if (resultCode * 1 === 0) {
        return data;
      }
    } catch (error) {
      return -1;
    }
  });

  /**
   * 取消订单
   */
  cancelOrderItem = flow(function* (info) {
    try {
      const { resultCode } = yield Serv.cancelOrder(this.tradeNo);
      // 取消成功更新详情数据
      if (resultCode == 0) {
        this.getOrderInfo();
        // this.getOrderProduct();
        this.getDeliveryList();

        const userInfo = Stores.AppMod.userInfo || {};
        const orderLabelList = (userInfo && userInfo.orderLabelList) || [];

        // 神策数据发送
        window.sensors.track('orderCancel', {
          orderNum: this.tradeNo,
          orderType: [
            '',
            (orderLabelList[0] && orderLabelList[0].label) || '零售订单',
            (orderLabelList[1] && orderLabelList[1].label) || '复消订单',
            '开卡订单',
            '升级订单',
            '开店订单',
            '促销订单'
          ][+info.orderType]
        });
      }
    } catch (error) {}
  });

  /**
   * 提交订单
   */
  commitCommet = flow(function* (params) {
    try {
      const { resultCode, resultMsg } = yield Serv.commitCommet(params);
      if (resultCode * 1 !== 0) {
        Toast.fail(resultMsg, 1);
      }
      return resultCode * 1;
    } catch (error) {
      return -1;
    }
  });

  /**
   * 修改订单
   */
  modifyApply = flow(function* (orderItem) {
    try {
      const { data, resultCode, resultMsg } = yield Serv.modifyOrder(orderItem.tradeNo);
      if (resultCode - 0 === 0) {
        window.app.routerGoTo({
          pathname: '/member/quickBuy',
          state: {
            isEdit: true,
            editData: data || {}
          }
        });
      } else {
        Toast.fail(resultMsg, 1);
      }
    } catch (err) {}
  });

  /**
   * 延迟发货
   */
  doDelay = flow(function* (tradeNo) {
    try {
      const { resultCode, resultMsg } = yield Serv.doDelay(tradeNo);
      if (resultCode - 0 === 0) {
        Toast.success('已成功为您延迟发货3天', 2);
        this.getOrderInfo();
      } else {
        Toast.fail(resultMsg, 1);
      }
    } catch (err) {}
  });

  /**
   * 申请快速退单
   */

  returnApply = flow(function* (orderItem, anotherTradeNos) {
    try {
      // 0自主下单、1店铺代客下单、2会员代客下单
      // 退单操作，是自主申请，还是代客申请（dgStatus为0，是自购订单，1或2是代客下单）
      const applyType = orderItem.dgStatus - 0 == 0 ? 0 : 1;

      // 代客申请时的客卡号
      const memberCard = (['1', '2'].includes(`${orderItem.dgStatus}`) && orderItem.userCard) || '';

      const params = {
        applyType,
        remark: '',
        type: 4,
        secondType: '401',
        memberCard,
        selectedOrderReqDtoList: [
          {
            tradeNo: this.tradeNo || orderItem.tradeNo,
            selectedItemReqDtoList: []
          }
        ]
      };
      // 有其他关联订单
      if (anotherTradeNos && anotherTradeNos.length) {
        const arr = anotherTradeNos.map((tradeNo) => ({ tradeNo, selectedItemReqDtoList: [] }));
        params.selectedOrderReqDtoList = params.selectedOrderReqDtoList.concat(arr);
      }
      const { resultCode, resultMsg, data } = yield Serv.afterSaleApply(params);
      const { result, msg, orderStatus } = data;
      if (resultCode - 0 === 0) {
        // result 校验结果 1 成功 0 失败
        if (result === 0) {
          let btns = [
            {
              text: '取消',
              onPress: () => {}
            },
            {
              text: '确认',
              onPress: () => {
                this.returnApply(orderItem, data.anotherTradeNos);
              }
            }
          ];
          // orderStatus "DELIVERY"=已发货, "WAIT_DELIVERY"=未发货
          if (orderStatus === 'DELIVERY') {
            btns = [
              {
                text: '确认'
              }
            ];
          }
          Modal.alert('', msg, btns);
        } else {
          Toast.success('提交成功，请确认款项，如有疑问请联系客服', 1);
          this.getOrderInfo();
          // this.getOrderProduct();
          this.getDeliveryList();
        }
      } else {
        Toast.fail(resultMsg, 1);
      }
    } catch (err) {}
  });

  /**
   * 获取赠品
   */
  getOrderGiftItem = flow(function* () {
    try {
      const { resultCode, data } = yield Serv.getOrderGiftItem(
        this.tradeNo,
        undefined,
        this.fromQRCode
      );
      // 取消成功更新详情数据
      if (resultCode == 0) {
        // this.getOrderInfo();
        // this.getOrderProduct();
        console.log('---getOrderGiftItem--');
        console.log(data);
        this.giftList = data;
      }
    } catch (error) {}
  });

  /**
   * 预售尾款下单
   */
  goCheckOrderAdvanceSaleTail(params) {
    Stores.CheckOrderMod.confirmOrder(params);
  }

  /**
   * 检查是否已支付定金
   */
  checkCanBuy = flow(function* () {
    const { itemId, activityId, tradeNo } = this.activityGoodsInfo;
    try {
      let params = {
        type: 0,
        activityId,
        itemId
      };
      if (tradeNo) {
        params.tradeNo = tradeNo;
      }
      const { data } = yield Serv.checkCanBuy(params);
      this.checkData = data || {};
    } catch (error) {}
  });

  /**
   * 整合预售信息
   *
   */
  prepareAdvanceInfo() {
    const {
      countDownForDepositEnd,
      countDownForDepositStart,
      countDownForTailEnd,
      countDownForTailStart
    } = this.activityGoodsInfo;
    if (countDownForDepositStart > 0 && countDownForDepositEnd > 0) {
      // 支付定金开始和结束时间都大于0，说明活动尚未开始
      this.advanceSaleStatus = advanceSaleStatusMap.ACTIVITYUNSTART;
    } else if (countDownForDepositStart < 0 && countDownForDepositEnd > 0) {
      // 支付定金阶段
      this.advanceSaleStatus = advanceSaleStatusMap.PAYFORDEPOSIT;
    } else if (
      countDownForDepositStart < 0 &&
      countDownForDepositEnd < 0 &&
      countDownForTailStart > 0 &&
      countDownForTailEnd > 0
    ) {
      // 待付尾款阶段
      this.advanceSaleStatus = advanceSaleStatusMap.WAITFORTAIL;
    } else if (
      countDownForDepositStart < 0 &&
      countDownForDepositEnd < 0 &&
      countDownForTailStart < 0 &&
      countDownForTailEnd > 0
    ) {
      // 支付尾款阶段
      this.advanceSaleStatus = advanceSaleStatusMap.PAYFORTAIL;
    } else if (
      countDownForDepositStart < 0 &&
      countDownForDepositEnd < 0 &&
      countDownForTailStart < 0 &&
      countDownForTailEnd < 0
    ) {
      // 活动结束
      this.advanceSaleStatus = advanceSaleStatusMap.ACTIVITYEND;
    }
  }

  /**
   * 删除订单
   */
  upLoadDeleteOrder = flow(function* (order) {
    try {
      const { resultCode } = yield Serv.deleteOrder(order.tradeNo);
      if (resultCode == '0') {
        console.log('DetailMod - upLoadDeleteOrder succ');
        Toast.success('订单删除成功！', 1);
        return true;
      }
    } catch (error) {
      console.log('DetailMod - upLoadDeleteOrder err', error);
    }
  });

  /**
   * 检查我是否能支付 - 来源分享支付
   */
  checkICanPay = flow(function* (tradeNo, openId) {
    try {
      const { resultCode, data } =
        (yield Serv.checkICanPay({
          tradeNo,
          openId: openId || undefined,
          userId: Stores.AppMod.userInfo.id
        })) || {};
      if (resultCode == 0 && data && !data.isDrawer) return true;
    } catch (e) {}
  });

  /**
   * 查询是否存在关联订单
   */
  checkRelateOrder = flow(function* (params) {
    try {
      const res = yield Serv.checkRelateOrder(params);
      return res;
    } catch (error) {}
  });

  getGiftWarehouseConfig = flow(function* () {
    try {
      const { giftWarehouseConfig = {}, newWarehouseConfig = {} } =
        yield Stores.AppMod.getGiftWarehouseConfig();
      this.giftWarehouseConfig = giftWarehouseConfig;
      this.newWarehouseConfig = newWarehouseConfig;
    } catch (error) {
      console.log('getGiftWarehouseConfig err', error);
    }
  });
}
const detailMod = new DetailMod();
export default detailMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/TradeManage/OrderList/Detail/DetailMod.js